import * as H from "react";
import we, { useContext as Je, createContext as Xe, forwardRef as Ie, createElement as ye } from "react";
var pe = { exports: {} }, le = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var je;
function Ke() {
  if (je) return le;
  je = 1;
  var e = Symbol.for("react.transitional.element"), r = Symbol.for("react.fragment");
  function t(o, s, a) {
    var d = null;
    if (a !== void 0 && (d = "" + a), s.key !== void 0 && (d = "" + s.key), "key" in s) {
      a = {};
      for (var f in s)
        f !== "key" && (a[f] = s[f]);
    } else a = s;
    return s = a.ref, {
      $$typeof: e,
      type: o,
      key: d,
      ref: s !== void 0 ? s : null,
      props: a
    };
  }
  return le.Fragment = r, le.jsx = t, le.jsxs = t, le;
}
var ie = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var He;
function Qe() {
  return He || (He = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(n) {
      if (n == null) return null;
      if (typeof n == "function")
        return n.$$typeof === ue ? null : n.displayName || n.name || null;
      if (typeof n == "string") return n;
      switch (n) {
        case V:
          return "Fragment";
        case X:
          return "Profiler";
        case P:
          return "StrictMode";
        case T:
          return "Suspense";
        case D:
          return "SuspenseList";
        case de:
          return "Activity";
      }
      if (typeof n == "object")
        switch (typeof n.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), n.$$typeof) {
          case j:
            return "Portal";
          case G:
            return n.displayName || "Context";
          case q:
            return (n._context.displayName || "Context") + ".Consumer";
          case W:
            var h = n.render;
            return n = n.displayName, n || (n = h.displayName || h.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
          case p:
            return h = n.displayName || null, h !== null ? h : e(n.type) || "Memo";
          case R:
            h = n._payload, n = n._init;
            try {
              return e(n(h));
            } catch {
            }
        }
      return null;
    }
    function r(n) {
      return "" + n;
    }
    function t(n) {
      try {
        r(n);
        var h = !1;
      } catch {
        h = !0;
      }
      if (h) {
        h = console;
        var b = h.error, x = typeof Symbol == "function" && Symbol.toStringTag && n[Symbol.toStringTag] || n.constructor.name || "Object";
        return b.call(
          h,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          x
        ), r(n);
      }
    }
    function o(n) {
      if (n === V) return "<>";
      if (typeof n == "object" && n !== null && n.$$typeof === R)
        return "<...>";
      try {
        var h = e(n);
        return h ? "<" + h + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function s() {
      var n = B.A;
      return n === null ? null : n.getOwner();
    }
    function a() {
      return Error("react-stack-top-frame");
    }
    function d(n) {
      if (oe.call(n, "key")) {
        var h = Object.getOwnPropertyDescriptor(n, "key").get;
        if (h && h.isReactWarning) return !1;
      }
      return n.key !== void 0;
    }
    function f(n, h) {
      function b() {
        S || (S = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          h
        ));
      }
      b.isReactWarning = !0, Object.defineProperty(n, "key", {
        get: b,
        configurable: !0
      });
    }
    function m() {
      var n = e(this.type);
      return I[n] || (I[n] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), n = this.props.ref, n !== void 0 ? n : null;
    }
    function w(n, h, b, x, z, K) {
      var C = b.ref;
      return n = {
        $$typeof: _,
        type: n,
        key: h,
        props: b,
        _owner: x
      }, (C !== void 0 ? C : null) !== null ? Object.defineProperty(n, "ref", {
        enumerable: !1,
        get: m
      }) : Object.defineProperty(n, "ref", { enumerable: !1, value: null }), n._store = {}, Object.defineProperty(n._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(n, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(n, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: z
      }), Object.defineProperty(n, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: K
      }), Object.freeze && (Object.freeze(n.props), Object.freeze(n)), n;
    }
    function y(n, h, b, x, z, K) {
      var C = h.children;
      if (C !== void 0)
        if (x)
          if (ne(C)) {
            for (x = 0; x < C.length; x++)
              v(C[x]);
            Object.freeze && Object.freeze(C);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else v(C);
      if (oe.call(h, "key")) {
        C = e(n);
        var O = Object.keys(h).filter(function(Q) {
          return Q !== "key";
        });
        x = 0 < O.length ? "{key: someKey, " + O.join(": ..., ") + ": ...}" : "{key: someKey}", ae[C + x] || (O = 0 < O.length ? "{" + O.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          x,
          C,
          O,
          C
        ), ae[C + x] = !0);
      }
      if (C = null, b !== void 0 && (t(b), C = "" + b), d(h) && (t(h.key), C = "" + h.key), "key" in h) {
        b = {};
        for (var U in h)
          U !== "key" && (b[U] = h[U]);
      } else b = h;
      return C && f(
        b,
        typeof n == "function" ? n.displayName || n.name || "Unknown" : n
      ), w(
        n,
        C,
        b,
        s(),
        z,
        K
      );
    }
    function v(n) {
      E(n) ? n._store && (n._store.validated = 1) : typeof n == "object" && n !== null && n.$$typeof === R && (n._payload.status === "fulfilled" ? E(n._payload.value) && n._payload.value._store && (n._payload.value._store.validated = 1) : n._store && (n._store.validated = 1));
    }
    function E(n) {
      return typeof n == "object" && n !== null && n.$$typeof === _;
    }
    var L = we, _ = Symbol.for("react.transitional.element"), j = Symbol.for("react.portal"), V = Symbol.for("react.fragment"), P = Symbol.for("react.strict_mode"), X = Symbol.for("react.profiler"), q = Symbol.for("react.consumer"), G = Symbol.for("react.context"), W = Symbol.for("react.forward_ref"), T = Symbol.for("react.suspense"), D = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), de = Symbol.for("react.activity"), ue = Symbol.for("react.client.reference"), B = L.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, oe = Object.prototype.hasOwnProperty, ne = Array.isArray, N = console.createTask ? console.createTask : function() {
      return null;
    };
    L = {
      react_stack_bottom_frame: function(n) {
        return n();
      }
    };
    var S, I = {}, u = L.react_stack_bottom_frame.bind(
      L,
      a
    )(), se = N(o(a)), ae = {};
    ie.Fragment = V, ie.jsx = function(n, h, b) {
      var x = 1e4 > B.recentlyCreatedOwnerStacks++;
      return y(
        n,
        h,
        b,
        !1,
        x ? Error("react-stack-top-frame") : u,
        x ? N(o(n)) : se
      );
    }, ie.jsxs = function(n, h, b) {
      var x = 1e4 > B.recentlyCreatedOwnerStacks++;
      return y(
        n,
        h,
        b,
        !0,
        x ? Error("react-stack-top-frame") : u,
        x ? N(o(n)) : se
      );
    };
  })()), ie;
}
var Le;
function er() {
  return Le || (Le = 1, process.env.NODE_ENV === "production" ? pe.exports = Ke() : pe.exports = Qe()), pe.exports;
}
var l = er();
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pe = (...e) => e.filter((r, t, o) => !!r && r.trim() !== "" && o.indexOf(r) === t).join(" ").trim();
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rr = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tr = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (r, t, o) => o ? o.toUpperCase() : t.toLowerCase()
);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Re = (e) => {
  const r = tr(e);
  return r.charAt(0).toUpperCase() + r.slice(1);
};
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var be = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const or = (e) => {
  for (const r in e)
    if (r.startsWith("aria-") || r === "role" || r === "title")
      return !0;
  return !1;
}, nr = Xe({}), sr = () => Je(nr), ar = Ie(
  ({ color: e, size: r, strokeWidth: t, absoluteStrokeWidth: o, className: s = "", children: a, iconNode: d, ...f }, m) => {
    const {
      size: w = 24,
      strokeWidth: y = 2,
      absoluteStrokeWidth: v = !1,
      color: E = "currentColor",
      className: L = ""
    } = sr() ?? {}, _ = o ?? v ? Number(t ?? y) * 24 / Number(r ?? w) : t ?? y;
    return ye(
      "svg",
      {
        ref: m,
        ...be,
        width: r ?? w ?? be.width,
        height: r ?? w ?? be.height,
        stroke: e ?? E,
        strokeWidth: _,
        className: Pe("lucide", L, s),
        ...!a && !or(f) && { "aria-hidden": "true" },
        ...f
      },
      [
        ...d.map(([j, V]) => ye(j, V)),
        ...Array.isArray(a) ? a : [a]
      ]
    );
  }
);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const k = (e, r) => {
  const t = Ie(
    ({ className: o, ...s }, a) => ye(ar, {
      ref: a,
      iconNode: r,
      className: Pe(
        `lucide-${rr(Re(e))}`,
        `lucide-${e}`,
        o
      ),
      ...s
    })
  );
  return t.displayName = Re(e), t;
};
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lr = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
], ir = k("arrow-left", lr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cr = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
], dr = k("arrow-right", cr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ur = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], Zt = k("calendar", ur);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mr = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Ft = k("check", mr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pr = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], Gt = k("chevron-down", pr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fr = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], hr = k("chevron-right", fr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gr = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], Wt = k("chevron-up", gr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const br = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], Bt = k("circle-plus", br);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cr = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], Ut = k("circle-x", Cr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xr = [
  ["path", { d: "M12 15V3", key: "m9g1x1" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["path", { d: "m7 10 5 5 5-5", key: "brsn70" }]
], Yt = k("download", xr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wr = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], yr = k("loader-circle", wr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kr = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
], vr = k("map-pin", kr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mr = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "m21 3-7 7", key: "1l2asr" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], _r = k("maximize-2", Mr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jr = [["path", { d: "M5 12h14", key: "1ays0h" }]], Hr = k("minus", jr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lr = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], Rr = k("plus", Lr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Er = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], qt = k("search", Er);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vr = [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506"
    }
  ]
], Sr = k("shopping-cart", Vr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ar = [
  ["path", { d: "M10 11v6", key: "nco0om" }],
  ["path", { d: "M14 11v6", key: "outv1u" }],
  ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6", key: "miytrc" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2", key: "e791ji" }]
], Nr = k("trash-2", Ar);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ir = [
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
      key: "lysw3i"
    }
  ],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
], Pr = k("truck", Ir);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tr = [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
], Dt = k("user", Tr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zr = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["path", { d: "M16 3.128a4 4 0 0 1 0 7.744", key: "16gr8j" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
], Jt = k("users", zr);
/**
 * @license lucide-react v1.0.1 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Or = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], $r = k("x", Or);
function Ee(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function Te(...e) {
  return (r) => {
    let t = !1;
    const o = e.map((s) => {
      const a = Ee(s, r);
      return !t && typeof a == "function" && (t = !0), a;
    });
    if (t)
      return () => {
        for (let s = 0; s < o.length; s++) {
          const a = o[s];
          typeof a == "function" ? a() : Ee(e[s], null);
        }
      };
  };
}
function Xt(...e) {
  return H.useCallback(Te(...e), e);
}
// @__NO_SIDE_EFFECTS__
function Zr(e) {
  const r = /* @__PURE__ */ Fr(e), t = H.forwardRef((o, s) => {
    const { children: a, ...d } = o, f = H.Children.toArray(a), m = f.find(Gr);
    if (m) {
      const w = m.props.children, y = f.map((v) => v === m ? H.Children.count(w) > 1 ? H.Children.only(null) : H.isValidElement(w) ? w.props.children : null : v);
      return /* @__PURE__ */ l.jsx(r, { ...d, ref: s, children: H.isValidElement(w) ? H.cloneElement(w, void 0, y) : null });
    }
    return /* @__PURE__ */ l.jsx(r, { ...d, ref: s, children: a });
  });
  return t.displayName = `${e}.Slot`, t;
}
var Z = /* @__PURE__ */ Zr("Slot");
// @__NO_SIDE_EFFECTS__
function Fr(e) {
  const r = H.forwardRef((t, o) => {
    const { children: s, ...a } = t;
    if (H.isValidElement(s)) {
      const d = Br(s), f = Wr(a, s.props);
      return s.type !== H.Fragment && (f.ref = o ? Te(o, d) : d), H.cloneElement(s, f);
    }
    return H.Children.count(s) > 1 ? H.Children.only(null) : null;
  });
  return r.displayName = `${e}.SlotClone`, r;
}
var ze = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Kt(e) {
  const r = ({ children: t }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: t });
  return r.displayName = `${e}.Slottable`, r.__radixId = ze, r;
}
function Gr(e) {
  return H.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === ze;
}
function Wr(e, r) {
  const t = { ...r };
  for (const o in r) {
    const s = e[o], a = r[o];
    /^on[A-Z]/.test(o) ? s && a ? t[o] = (...f) => {
      const m = a(...f);
      return s(...f), m;
    } : s && (t[o] = s) : o === "style" ? t[o] = { ...s, ...a } : o === "className" && (t[o] = [s, a].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function Br(e) {
  let r = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = Object.getOwnPropertyDescriptor(e, "ref")?.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
function Oe(e) {
  var r, t, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var s = e.length;
    for (r = 0; r < s; r++) e[r] && (t = Oe(e[r])) && (o && (o += " "), o += t);
  } else for (t in e) e[t] && (o && (o += " "), o += t);
  return o;
}
function Ur() {
  for (var e, r, t = 0, o = "", s = arguments.length; t < s; t++) (e = arguments[t]) && (r = Oe(e)) && (o && (o += " "), o += r);
  return o;
}
const _e = "-", Yr = (e) => {
  const r = Dr(e), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: o
  } = e;
  return {
    getClassGroupId: (d) => {
      const f = d.split(_e);
      return f[0] === "" && f.length !== 1 && f.shift(), $e(f, r) || qr(d);
    },
    getConflictingClassGroupIds: (d, f) => {
      const m = t[d] || [];
      return f && o[d] ? [...m, ...o[d]] : m;
    }
  };
}, $e = (e, r) => {
  if (e.length === 0)
    return r.classGroupId;
  const t = e[0], o = r.nextPart.get(t), s = o ? $e(e.slice(1), o) : void 0;
  if (s)
    return s;
  if (r.validators.length === 0)
    return;
  const a = e.join(_e);
  return r.validators.find(({
    validator: d
  }) => d(a))?.classGroupId;
}, Ve = /^\[(.+)\]$/, qr = (e) => {
  if (Ve.test(e)) {
    const r = Ve.exec(e)[1], t = r?.substring(0, r.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}, Dr = (e) => {
  const {
    theme: r,
    classGroups: t
  } = e, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const s in t)
    ke(t[s], o, s, r);
  return o;
}, ke = (e, r, t, o) => {
  e.forEach((s) => {
    if (typeof s == "string") {
      const a = s === "" ? r : Se(r, s);
      a.classGroupId = t;
      return;
    }
    if (typeof s == "function") {
      if (Jr(s)) {
        ke(s(o), r, t, o);
        return;
      }
      r.validators.push({
        validator: s,
        classGroupId: t
      });
      return;
    }
    Object.entries(s).forEach(([a, d]) => {
      ke(d, Se(r, a), t, o);
    });
  });
}, Se = (e, r) => {
  let t = e;
  return r.split(_e).forEach((o) => {
    t.nextPart.has(o) || t.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(o);
  }), t;
}, Jr = (e) => e.isThemeGetter, Xr = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let r = 0, t = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  const s = (a, d) => {
    t.set(a, d), r++, r > e && (r = 0, o = t, t = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let d = t.get(a);
      if (d !== void 0)
        return d;
      if ((d = o.get(a)) !== void 0)
        return s(a, d), d;
    },
    set(a, d) {
      t.has(a) ? t.set(a, d) : s(a, d);
    }
  };
}, ve = "!", Me = ":", Kr = Me.length, Qr = (e) => {
  const {
    prefix: r,
    experimentalParseClassName: t
  } = e;
  let o = (s) => {
    const a = [];
    let d = 0, f = 0, m = 0, w;
    for (let _ = 0; _ < s.length; _++) {
      let j = s[_];
      if (d === 0 && f === 0) {
        if (j === Me) {
          a.push(s.slice(m, _)), m = _ + Kr;
          continue;
        }
        if (j === "/") {
          w = _;
          continue;
        }
      }
      j === "[" ? d++ : j === "]" ? d-- : j === "(" ? f++ : j === ")" && f--;
    }
    const y = a.length === 0 ? s : s.substring(m), v = et(y), E = v !== y, L = w && w > m ? w - m : void 0;
    return {
      modifiers: a,
      hasImportantModifier: E,
      baseClassName: v,
      maybePostfixModifierPosition: L
    };
  };
  if (r) {
    const s = r + Me, a = o;
    o = (d) => d.startsWith(s) ? a(d.substring(s.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: d,
      maybePostfixModifierPosition: void 0
    };
  }
  if (t) {
    const s = o;
    o = (a) => t({
      className: a,
      parseClassName: s
    });
  }
  return o;
}, et = (e) => e.endsWith(ve) ? e.substring(0, e.length - 1) : e.startsWith(ve) ? e.substring(1) : e, rt = (e) => {
  const r = Object.fromEntries(e.orderSensitiveModifiers.map((o) => [o, !0]));
  return (o) => {
    if (o.length <= 1)
      return o;
    const s = [];
    let a = [];
    return o.forEach((d) => {
      d[0] === "[" || r[d] ? (s.push(...a.sort(), d), a = []) : a.push(d);
    }), s.push(...a.sort()), s;
  };
}, tt = (e) => ({
  cache: Xr(e.cacheSize),
  parseClassName: Qr(e),
  sortModifiers: rt(e),
  ...Yr(e)
}), ot = /\s+/, nt = (e, r) => {
  const {
    parseClassName: t,
    getClassGroupId: o,
    getConflictingClassGroupIds: s,
    sortModifiers: a
  } = r, d = [], f = e.trim().split(ot);
  let m = "";
  for (let w = f.length - 1; w >= 0; w -= 1) {
    const y = f[w], {
      isExternal: v,
      modifiers: E,
      hasImportantModifier: L,
      baseClassName: _,
      maybePostfixModifierPosition: j
    } = t(y);
    if (v) {
      m = y + (m.length > 0 ? " " + m : m);
      continue;
    }
    let V = !!j, P = o(V ? _.substring(0, j) : _);
    if (!P) {
      if (!V) {
        m = y + (m.length > 0 ? " " + m : m);
        continue;
      }
      if (P = o(_), !P) {
        m = y + (m.length > 0 ? " " + m : m);
        continue;
      }
      V = !1;
    }
    const X = a(E).join(":"), q = L ? X + ve : X, G = q + P;
    if (d.includes(G))
      continue;
    d.push(G);
    const W = s(P, V);
    for (let T = 0; T < W.length; ++T) {
      const D = W[T];
      d.push(q + D);
    }
    m = y + (m.length > 0 ? " " + m : m);
  }
  return m;
};
function st() {
  let e = 0, r, t, o = "";
  for (; e < arguments.length; )
    (r = arguments[e++]) && (t = Ze(r)) && (o && (o += " "), o += t);
  return o;
}
const Ze = (e) => {
  if (typeof e == "string")
    return e;
  let r, t = "";
  for (let o = 0; o < e.length; o++)
    e[o] && (r = Ze(e[o])) && (t && (t += " "), t += r);
  return t;
};
function at(e, ...r) {
  let t, o, s, a = d;
  function d(m) {
    const w = r.reduce((y, v) => v(y), e());
    return t = tt(w), o = t.cache.get, s = t.cache.set, a = f, f(m);
  }
  function f(m) {
    const w = o(m);
    if (w)
      return w;
    const y = nt(m, t);
    return s(m, y), y;
  }
  return function() {
    return a(st.apply(null, arguments));
  };
}
const M = (e) => {
  const r = (t) => t[e] || [];
  return r.isThemeGetter = !0, r;
}, Fe = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Ge = /^\((?:(\w[\w-]*):)?(.+)\)$/i, lt = /^\d+\/\d+$/, it = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, ct = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, dt = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, ut = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, mt = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ee = (e) => lt.test(e), g = (e) => !!e && !Number.isNaN(Number(e)), Y = (e) => !!e && Number.isInteger(Number(e)), Ce = (e) => e.endsWith("%") && g(e.slice(0, -1)), $ = (e) => it.test(e), pt = () => !0, ft = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  ct.test(e) && !dt.test(e)
), We = () => !1, ht = (e) => ut.test(e), gt = (e) => mt.test(e), bt = (e) => !i(e) && !c(e), Ct = (e) => re(e, Ye, We), i = (e) => Fe.test(e), J = (e) => re(e, qe, ft), xe = (e) => re(e, vt, g), Ae = (e) => re(e, Be, We), xt = (e) => re(e, Ue, gt), fe = (e) => re(e, De, ht), c = (e) => Ge.test(e), ce = (e) => te(e, qe), wt = (e) => te(e, Mt), Ne = (e) => te(e, Be), yt = (e) => te(e, Ye), kt = (e) => te(e, Ue), he = (e) => te(e, De, !0), re = (e, r, t) => {
  const o = Fe.exec(e);
  return o ? o[1] ? r(o[1]) : t(o[2]) : !1;
}, te = (e, r, t = !1) => {
  const o = Ge.exec(e);
  return o ? o[1] ? r(o[1]) : t : !1;
}, Be = (e) => e === "position" || e === "percentage", Ue = (e) => e === "image" || e === "url", Ye = (e) => e === "length" || e === "size" || e === "bg-size", qe = (e) => e === "length", vt = (e) => e === "number", Mt = (e) => e === "family-name", De = (e) => e === "shadow", _t = () => {
  const e = M("color"), r = M("font"), t = M("text"), o = M("font-weight"), s = M("tracking"), a = M("leading"), d = M("breakpoint"), f = M("container"), m = M("spacing"), w = M("radius"), y = M("shadow"), v = M("inset-shadow"), E = M("text-shadow"), L = M("drop-shadow"), _ = M("blur"), j = M("perspective"), V = M("aspect"), P = M("ease"), X = M("animate"), q = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], G = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], W = () => [...G(), c, i], T = () => ["auto", "hidden", "clip", "visible", "scroll"], D = () => ["auto", "contain", "none"], p = () => [c, i, m], R = () => [ee, "full", "auto", ...p()], de = () => [Y, "none", "subgrid", c, i], ue = () => ["auto", {
    span: ["full", Y, c, i]
  }, Y, c, i], B = () => [Y, "auto", c, i], oe = () => ["auto", "min", "max", "fr", c, i], ne = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], N = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], S = () => ["auto", ...p()], I = () => [ee, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...p()], u = () => [e, c, i], se = () => [...G(), Ne, Ae, {
    position: [c, i]
  }], ae = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], n = () => ["auto", "cover", "contain", yt, Ct, {
    size: [c, i]
  }], h = () => [Ce, ce, J], b = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    w,
    c,
    i
  ], x = () => ["", g, ce, J], z = () => ["solid", "dashed", "dotted", "double"], K = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], C = () => [g, Ce, Ne, Ae], O = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    _,
    c,
    i
  ], U = () => ["none", g, c, i], Q = () => ["none", g, c, i], ge = () => [g, c, i], me = () => [ee, "full", ...p()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [$],
      breakpoint: [$],
      color: [pt],
      container: [$],
      "drop-shadow": [$],
      ease: ["in", "out", "in-out"],
      font: [bt],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [$],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [$],
      shadow: [$],
      spacing: ["px", g],
      text: [$],
      "text-shadow": [$],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", ee, i, c, V]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [g, i, c, f]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": q()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": q()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: W()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: T()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": T()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": T()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: D()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": D()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": D()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: R()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": R()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": R()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: R()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: R()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: R()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: R()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: R()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: R()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Y, "auto", c, i]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [ee, "full", "auto", f, ...p()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [g, ee, "auto", "initial", "none", i]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", g, c, i]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", g, c, i]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Y, "first", "last", "none", c, i]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": de()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ue()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": B()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": B()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": de()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ue()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": B()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": B()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": oe()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": oe()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: p()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": p()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": p()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...ne(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...N(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...N()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...ne()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...N(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...N(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": ne()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...N(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...N()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: p()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: p()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: p()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: p()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: p()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: p()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: p()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: p()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: p()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: S()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: S()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: S()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: S()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: S()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: S()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: S()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: S()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: S()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": p()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": p()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: I()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [f, "screen", ...I()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          f,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...I()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          f,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [d]
          },
          ...I()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...I()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...I()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...I()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", t, ce, J]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [o, c, xe]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Ce, i]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [wt, i, r]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [s, c, i]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [g, "none", c, xe]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...p()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", c, i]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", c, i]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: u()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: u()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...z(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [g, "from-font", "auto", c, J]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: u()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [g, "auto", c, i]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: p()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", c, i]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", c, i]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: se()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ae()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: n()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Y, c, i],
          radial: ["", c, i],
          conic: [Y, c, i]
        }, kt, xt]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: u()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: h()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: h()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: h()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: u()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: u()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: u()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: b()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": b()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": b()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": b()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": b()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": b()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": b()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": b()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": b()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": b()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": b()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": b()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": b()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": b()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": b()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: x()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": x()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": x()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": x()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": x()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": x()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": x()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": x()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": x()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": x()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": x()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...z(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...z(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: u()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": u()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": u()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": u()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": u()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": u()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": u()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": u()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": u()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: u()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...z(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [g, c, i]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", g, ce, J]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: u()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          y,
          he,
          fe
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: u()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", v, he, fe]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": u()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: x()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: u()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [g, J]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": u()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": x()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": u()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", E, he, fe]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": u()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [g, c, i]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...K(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": K()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [g]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": C()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": C()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": u()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": u()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": C()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": C()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": u()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": u()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": C()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": C()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": u()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": u()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": C()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": C()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": u()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": u()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": C()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": C()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": u()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": u()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": C()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": C()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": u()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": u()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": C()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": C()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": u()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": u()
      }],
      "mask-image-radial": [{
        "mask-radial": [c, i]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": C()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": C()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": u()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": u()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": G()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [g]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": C()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": C()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": u()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": u()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: se()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: ae()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: n()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", c, i]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          c,
          i
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: O()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [g, c, i]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [g, c, i]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          L,
          he,
          fe
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": u()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", g, c, i]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [g, c, i]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", g, c, i]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [g, c, i]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", g, c, i]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          c,
          i
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": O()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [g, c, i]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [g, c, i]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", g, c, i]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [g, c, i]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", g, c, i]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [g, c, i]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [g, c, i]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", g, c, i]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": p()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": p()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": p()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", c, i]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [g, "initial", c, i]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", P, c, i]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [g, c, i]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", X, c, i]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [j, c, i]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": W()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: U()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": U()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": U()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": U()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: Q()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": Q()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": Q()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": Q()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: ge()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": ge()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": ge()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [c, i, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: W()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: me()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": me()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": me()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": me()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: u()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: u()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", c, i]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": p()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": p()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": p()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": p()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": p()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": p()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": p()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": p()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": p()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": p()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": p()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": p()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": p()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": p()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": p()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": p()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": p()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": p()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", c, i]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...u()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [g, ce, J, xe]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...u()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, jt = /* @__PURE__ */ at(_t);
function F(...e) {
  return jt(Ur(e));
}
const Ht = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
  xl: "w-8 h-8",
  "2xl": "w-10 h-10",
  "3xl": "w-12 h-12",
  "4xl": "w-16 h-16",
  "5xl": "w-20 h-20"
}, Lt = {
  primary: "text-primary",
  secondary: "text-secondary",
  success: "text-success",
  error: "text-error",
  warning: "text-warning",
  info: "text-info",
  muted: "text-muted-foreground",
  current: "text-current"
};
function A(e) {
  const { size: r, color: t, className: o, children: s, ...a } = e, d = r || "md", f = t || "current", m = o || "", w = Ht[d], y = Lt[f], v = we.Children.only(s), E = v.props.className || "", L = `${w} ${y} ${E} ${m}`.trim();
  return we.cloneElement(v, {
    ...v.props,
    ...a,
    // Pass through additional props like data-testid
    className: L
  });
}
function Rt({ className: e, asChild: r = !1 }) {
  const t = r ? Z : "svg";
  return /* @__PURE__ */ l.jsx(
    t,
    {
      className: F(e),
      fill: "none",
      height: "38",
      viewBox: "0 0 39 38",
      width: "39",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ l.jsx(
        "path",
        {
          d: "M38.4033 38V31.9785H33.819L31.4584 29.3687L29.0865 31.9785H13.9716V19.8147H9.09316L15.1443 6.12028H20.9803L23.0635 10.8118V6.12028H30.2873L31.5413 9.6558L32.8036 6.12028H38.4033V0H0.40332V38H38.4033ZM34.5912 30.4555H38.4033L33.3607 25.1081L38.4033 19.8216H34.652L31.5375 23.2248L28.4534 19.8216H24.6405L29.6534 25.1385L24.6405 30.4555H28.3478L31.4774 27.0218L34.5919 30.4555H34.5912ZM35.4834 25.1127L38.4033 28.2196V22.0316L35.4834 25.1127ZM18.4875 27.9946V26.3386H24.4885V23.9385H18.4875V22.2824H24.6405V19.8216H15.5858V30.4562H24.6405V27.9954H18.4875V27.9946ZM35.532 18.278H38.4033V7.64332H33.9368L31.5512 14.2667L29.1815 7.64332H24.639V18.278H27.5102V10.8338L30.2447 18.278H32.7968L35.5313 10.8186V18.278H35.532ZM21.3732 18.278H24.6397L19.9452 7.64332H16.2075L11.513 18.278H14.7035L15.5851 16.1508H20.4772L21.3732 18.278ZM19.474 13.7659H16.5875L18.0308 10.2866L19.474 13.7659Z",
          fill: "#006FCF"
        }
      )
    }
  );
}
Rt.displayName = "IconAmex";
function Qt(e) {
  return /* @__PURE__ */ l.jsx(A, { ...e, children: /* @__PURE__ */ l.jsx(ir, {}) });
}
function eo(e) {
  return /* @__PURE__ */ l.jsx(A, { ...e, children: /* @__PURE__ */ l.jsx(dr, {}) });
}
function ro(e) {
  return /* @__PURE__ */ l.jsx(A, { ...e, children: /* @__PURE__ */ l.jsx(Sr, {}) });
}
function to(e) {
  return /* @__PURE__ */ l.jsx(A, { ...e, children: /* @__PURE__ */ l.jsx(hr, {}) });
}
const Et = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
  xl: "w-8 h-8",
  "2xl": "w-10 h-10",
  "3xl": "w-12 h-12",
  "4xl": "w-16 h-16",
  "5xl": "w-20 h-20"
}, Vt = {
  primary: "fill-primary",
  secondary: "fill-secondary",
  success: "fill-success",
  error: "fill-error",
  warning: "fill-warning",
  info: "fill-info",
  muted: "fill-muted-foreground",
  current: "fill-current"
};
function St({
  className: e,
  asChild: r = !1,
  size: t = "lg",
  color: o
}) {
  const s = r ? Z : "svg", a = t ? Et[t] : "", d = o ? Vt[o] : "fill-[--brand-followus]";
  return /* @__PURE__ */ l.jsx(
    s,
    {
      className: F(a, d, e),
      fill: "none",
      height: "32",
      viewBox: "0 0 28 28",
      width: "28",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ l.jsx("path", { d: "M4 0H24C26.1875 0 28 1.8125 28 4V24C28 26.25 26.1875 28 24 28H15.9375V18.9375H20.25L21.125 14H15.9375V12.3125C15.9375 9.6875 16.9375 8.6875 19.5625 8.6875C20.375 8.6875 21 8.75 21.375 8.75V4.375C20.6875 4.125 18.9375 3.9375 17.9375 3.9375C12.5625 3.9375 10.125 6.5 10.125 11.9375V14H6.8125V18.9375H10.125V28H4C1.75 28 0 26.25 0 24V4C0 1.8125 1.75 0 4 0Z" })
    }
  );
}
St.displayName = "IconFacebook";
function oo(e) {
  return /* @__PURE__ */ l.jsx(A, { ...e, children: /* @__PURE__ */ l.jsx(vr, {}) });
}
function At({ className: e, asChild: r = !1 }) {
  const t = r ? Z : "svg";
  return /* @__PURE__ */ l.jsx(
    t,
    {
      className: F(e, "fill-[--brand-followus]"),
      fill: "none",
      height: "32",
      viewBox: "0 0 28 28",
      width: "28",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ l.jsx("path", { d: "M12.125 11.25C13.125 10.625 14.375 10.5 15.4375 11.0625C16.5 11.5625 17.25 12.625 17.3125 13.8125C17.375 15 16.8125 16.125 15.8125 16.8125C14.8125 17.4375 13.5625 17.5625 12.5 17C11.4375 16.5 10.75 15.4375 10.625 14.25C10.5625 13.0625 11.125 11.9375 12.125 11.25ZM21 7C21.3125 7.3125 21.625 7.6875 21.75 8.125C22.1875 9.25 22.1875 11.6875 22.1875 13.3125C22.1875 13.5625 22.1875 13.8125 22.1875 14C22.1875 14.25 22.1875 14.5 22.1875 14.75C22.1875 16.3125 22.1875 18.8125 21.75 19.9375C21.625 20.375 21.375 20.75 21 21.0625C20.6875 21.375 20.3125 21.625 19.875 21.8125C18.75 22.25 16.25 22.25 14.6875 22.25C14.4375 22.25 14.1875 22.25 14 22.25C13.75 22.25 13.5 22.25 13.25 22.25C11.6875 22.25 9.1875 22.25 8.0625 21.8125C7.625 21.625 7.25 21.375 6.9375 21.0625C6.625 20.75 6.375 20.375 6.1875 19.9375C5.75 18.8125 5.75 16.3125 5.75 14.75C5.75 14.4375 5.75 14.25 5.75 14C5.75 13.8125 5.75 13.5625 5.75 13.3125C5.75 11.75 5.75 9.25 6.1875 8.125C6.375 7.6875 6.625 7.3125 6.9375 7C7.25 6.6875 7.625 6.375 8.0625 6.25C9.1875 5.8125 11.6875 5.8125 13.25 5.8125C13.5 5.8125 13.75 5.8125 14 5.8125C14.1875 5.8125 14.4375 5.8125 14.6875 5.8125C16.25 5.8125 18.75 5.8125 19.875 6.25C20.3125 6.375 20.6875 6.6875 21 7ZM16.8125 9.75C15.3125 8.75 13.3125 8.625 11.6875 9.4375C10.0625 10.25 9 11.875 8.875 13.6875C8.75 15.5 9.625 17.25 11.125 18.3125C12.625 19.3125 14.5625 19.4375 16.25 18.625C17.875 17.8125 18.9375 16.1875 19.0625 14.375C19.1875 12.5625 18.3125 10.8125 16.8125 9.75ZM18.625 9.6875C18.875 9.8125 19.0625 9.875 19.3125 9.875C19.5 9.875 19.625 9.875 19.75 9.8125C19.9375 9.75 20.0625 9.625 20.1875 9.5C20.25 9.4375 20.375 9.3125 20.4375 9.125C20.5 9 20.5 8.8125 20.5 8.6875C20.5 8.4375 20.4375 8.1875 20.3125 8C20.1875 7.8125 20 7.6875 19.75 7.5625C19.5625 7.5 19.3125 7.5 19.0625 7.5C18.8125 7.5625 18.625 7.6875 18.4375 7.8125C18.3125 8 18.1875 8.1875 18.125 8.4375C18.0625 8.6875 18.125 8.9375 18.1875 9.125C18.3125 9.375 18.4375 9.5625 18.625 9.6875ZM28 4V24C28 26.25 26.1875 28 24 28H4C1.75 28 0 26.25 0 24V4C0 1.8125 1.75 0 4 0H24C26.1875 0 28 1.8125 28 4ZM22.3125 22.3125C23.4375 21.1875 23.8125 19.75 23.875 18.125C24 16.5 24 11.5625 23.875 9.875C23.8125 8.3125 23.4375 6.875 22.3125 5.6875C21.125 4.5625 19.6875 4.1875 18.125 4.125C16.4375 4 11.5 4 9.875 4.125C8.25 4.1875 6.8125 4.5625 5.6875 5.6875C4.5 6.875 4.125 8.3125 4.0625 9.875C3.9375 11.5625 3.9375 16.5 4.0625 18.125C4.125 19.75 4.5 21.1875 5.6875 22.3125C6.8125 23.5 8.25 23.875 9.875 23.9375C11.5 24.0625 16.4375 24.0625 18.125 23.9375C19.6875 23.875 21.125 23.5 22.3125 22.3125Z" })
    }
  );
}
At.displayName = "IconInstagram";
function Nt({ className: e, asChild: r = !1 }) {
  const t = r ? Z : "svg";
  return /* @__PURE__ */ l.jsxs(
    t,
    {
      className: F(e),
      fill: "none",
      height: "38",
      viewBox: "0 0 91 38",
      width: "91",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l.jsx("rect", { height: "38", width: "90.1616" }),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M73.4575 4H16.7041C11.897 4 8 7.89697 8 12.7041V25.2959C8 30.103 11.897 34 16.7041 34H73.4575C78.2647 34 82.1616 30.103 82.1616 25.2959V12.7041C82.1616 7.89697 78.2647 4 73.4575 4Z",
            fill: "#FFB3C7"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M67.3868 17.1445C65.292 15.714 62.4309 16.2574 61.005 18.3521C59.5744 20.4469 60.1179 23.308 62.2126 24.7339C63.7732 25.7976 65.8262 25.7976 67.3868 24.7339V25.2913H69.9924V16.5872H67.3868V17.1445ZM65.0133 23.178C63.7779 23.1129 62.8257 22.0539 62.8907 20.8185C62.9558 19.583 64.0147 18.6308 65.2502 18.6958C66.4393 18.7609 67.3728 19.7409 67.3728 20.9346C67.3403 22.2026 66.2813 23.2058 65.0087 23.1733L65.0133 23.178Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ l.jsx("path", { d: "M31.6415 12.7087H28.915V25.2958H31.6415V12.7087Z", fill: "black" }),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M55.5754 16.3548C54.535 16.2944 53.5318 16.7496 52.8908 17.5717V16.5917H50.2944V25.2958H52.9233V20.7208C52.8444 19.7083 53.6014 18.8258 54.614 18.7515C54.7022 18.7468 54.7905 18.7422 54.8787 18.7515C56.026 18.7515 56.6809 19.4342 56.6809 20.7069V25.3005H59.2865V19.764C59.2865 17.7389 57.6748 16.3595 55.5754 16.3595V16.3548Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M39.8905 17.1445C37.7957 15.714 34.9346 16.2574 33.5086 18.3521C32.0781 20.4469 32.6215 23.308 34.7163 24.7339C36.2769 25.7976 38.3298 25.7976 39.8905 24.7339V25.2913H42.4961V16.5872H39.8905V17.1445ZM37.517 23.178C36.2815 23.1129 35.3294 22.0586 35.3944 20.8185C35.4594 19.583 36.5138 18.6308 37.7539 18.6958C38.9429 18.7609 39.8765 19.7409 39.8765 20.9346C39.844 22.2026 38.785 23.2058 37.517 23.1733V23.178Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M46.5276 17.7203V16.587H43.8569V25.2911H46.5323V21.227C46.5323 19.8569 48.0186 19.1184 49.0497 19.1184C49.059 19.1184 49.0683 19.1184 49.0822 19.1184V16.587C48.1022 16.5591 47.1639 16.9772 46.5276 17.7203Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M72.7609 22.2072C71.8552 22.2072 71.126 22.941 71.126 23.8421C71.126 24.7478 71.8598 25.477 72.7609 25.477C73.6666 25.477 74.3958 24.7431 74.3958 23.8421C74.3958 22.9364 73.662 22.2072 72.7609 22.2072Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M27.0339 12.7041H24.2053C24.2146 15.0032 23.1277 17.1676 21.2838 18.5378L20.1644 19.3785L24.5026 25.2958H28.0697L24.0752 19.8523C25.9796 17.9619 27.0432 15.3887 27.0293 12.7041H27.0339Z",
            fill: "black"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M19.8205 12.7041H16.9873V25.2958H19.8205V12.7041Z",
            fill: "black"
          }
        )
      ]
    }
  );
}
Nt.displayName = "IconKlarna";
function no(e) {
  return /* @__PURE__ */ l.jsx(A, { ...e, children: /* @__PURE__ */ l.jsx(yr, {}) });
}
function It({ className: e, asChild: r = !1 }) {
  const t = r ? Z : "svg";
  return /* @__PURE__ */ l.jsxs(
    t,
    {
      className: F(e),
      fill: "none",
      height: "38",
      viewBox: "0 0 68 38",
      width: "68",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l.jsx("rect", { height: "38", width: "67.7623" }),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M40.8822 6.42627H26.8853V31.5807H40.8822V6.42627Z",
            fill: "#FF5F00"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M27.7738 19.0013C27.7694 14.0912 30.0222 9.45671 33.8836 6.42627C26.9384 0.965256 16.8829 2.16943 11.4219 9.11901C5.96086 16.0641 7.16504 26.1197 14.1146 31.5807C19.9178 36.1397 28.0849 36.1397 33.8836 31.5807C30.0222 28.5503 27.7694 23.9113 27.7738 19.0057V19.0013Z",
            fill: "#EB001B"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M59.7624 19.0013C59.7624 27.8349 52.5996 34.9978 43.766 34.9978C40.1801 34.9978 36.7009 33.7936 33.8793 31.5763C40.8244 26.1153 42.0286 16.0553 36.5676 9.11017C35.7811 8.11039 34.8791 7.20837 33.8793 6.42188C40.8244 0.960862 50.88 2.16504 56.341 9.11461C58.5583 11.9318 59.7624 15.4154 59.7624 19.0013Z",
            fill: "#F79E1B"
          }
        ),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M58.2383 28.9147V28.3992H58.4471V28.2926H57.9183V28.3992H58.1272V28.9147H58.2427H58.2383ZM59.2647 28.9147V28.2926H59.1047L58.9181 28.7192L58.7315 28.2926H58.5715V28.9147H58.6871V28.4481L58.8604 28.8525H58.9803L59.1536 28.4481V28.9191H59.2692L59.2647 28.9147Z",
            fill: "#F79E1B"
          }
        )
      ]
    }
  );
}
It.displayName = "IconMastercard";
function so(e) {
  return /* @__PURE__ */ l.jsx(A, { ...e, children: /* @__PURE__ */ l.jsx(_r, {}) });
}
function ao(e) {
  return /* @__PURE__ */ l.jsx(A, { ...e, children: /* @__PURE__ */ l.jsx(Hr, {}) });
}
function Pt({ className: e, asChild: r = !1 }) {
  const t = r ? Z : "svg";
  return /* @__PURE__ */ l.jsxs(
    t,
    {
      className: F(e),
      fill: "none",
      height: "38",
      viewBox: "0 0 111 38",
      width: "111",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l.jsx("rect", { height: "38", width: "110.359" }),
        /* @__PURE__ */ l.jsx(
          "mask",
          {
            height: "26",
            id: "mask0_34_115",
            maskUnits: "userSpaceOnUse",
            width: "95",
            x: "8",
            y: "6",
            children: /* @__PURE__ */ l.jsx("path", { d: "M102.359 6.5H8V31.5H102.359V6.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ l.jsxs("g", { mask: "url(#mask0_34_115)", children: [
          /* @__PURE__ */ l.jsx(
            "path",
            {
              d: "M42.444 21.6496C45.2729 21.6496 47.675 19.5856 48.1124 16.7879C48.5533 13.9654 46.3523 11.5063 43.2271 11.4993H38.1936C37.9996 11.4993 37.8338 11.6404 37.8056 11.8309L35.5587 26.0773C35.5235 26.2996 35.6928 26.4971 35.9185 26.4971H38.5816C38.7756 26.4971 38.9414 26.356 38.9696 26.1655L39.6292 21.9812C39.661 21.7907 39.8232 21.6496 40.0172 21.6496H42.4405H42.444ZM44.6733 16.6609C44.5075 17.7052 43.7033 18.4743 42.1583 18.4743H40.1866L40.7862 14.6816H42.7227C44.317 14.6816 44.8355 15.6236 44.6733 16.6644",
              fill: "#003087"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              d: "M59.6538 15.9906H57.1247C56.9307 15.9906 56.7649 16.1317 56.7367 16.3222L56.6556 16.8479C56.6556 16.8479 54.6909 14.7028 51.2165 16.1493C49.2235 16.9819 48.2676 18.6966 47.8585 19.9491C47.8585 19.9491 46.564 23.77 49.4881 25.8657C49.4881 25.8657 52.1971 27.8837 55.2482 25.7422L55.1953 26.0774C55.16 26.2996 55.3328 26.4972 55.5551 26.4972H58.0841C58.2781 26.4972 58.4439 26.3561 58.4721 26.1656L60.01 16.4104C60.0453 16.1881 59.8725 15.9906 59.6502 15.9906M55.9395 21.3815C55.7173 22.7821 54.5709 23.8123 53.1001 23.8123C52.8108 23.8123 52.5427 23.7735 52.3064 23.6959C51.2165 23.3466 50.5921 22.2988 50.772 21.1627C50.9943 19.7621 52.1442 18.7319 53.615 18.7319C53.9043 18.7319 54.1724 18.7707 54.4087 18.8483C55.4986 19.1976 56.1194 20.2454 55.9395 21.3815Z",
              fill: "#003087"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              d: "M78.8562 21.6496C81.6851 21.6496 84.0872 19.5856 84.5246 16.7879C84.969 13.9654 82.7644 11.5063 79.6392 11.4993H74.6058C74.4118 11.4993 74.246 11.6404 74.2178 11.8309L71.9709 26.0773C71.9356 26.2996 72.1085 26.4971 72.3307 26.4971H74.9938C75.1878 26.4971 75.3536 26.356 75.3818 26.1655L76.0414 21.9812C76.0696 21.7907 76.2354 21.6496 76.4294 21.6496H78.8491H78.8562ZM81.0854 16.6609C80.9197 17.7052 80.1154 18.4743 78.5705 18.4743H76.5987L77.1983 14.6816H79.1348C80.7292 14.6816 81.2477 15.6236 81.0854 16.6644",
              fill: "#0070E0"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              d: "M96.0695 15.9906H93.5405C93.3465 15.9906 93.1807 16.1317 93.1525 16.3222L93.0713 16.8479C93.0713 16.8479 91.1066 14.7028 87.6322 16.1493C85.6393 16.9819 84.6834 18.6966 84.2743 19.9491C84.2743 19.9491 82.9797 23.77 85.9039 25.8657C85.9039 25.8657 88.6128 27.8837 91.6639 25.7422L91.611 26.0774C91.5758 26.2996 91.7486 26.4972 91.9708 26.4972H94.4999C94.6939 26.4972 94.8597 26.3561 94.8879 26.1656L96.4258 16.4104C96.4611 16.1881 96.2882 15.9906 96.066 15.9906M92.3518 21.3815C92.1295 22.7821 90.9832 23.8123 89.5123 23.8123C89.2231 23.8123 88.955 23.7735 88.7186 23.6959C87.6287 23.3466 87.0044 22.2988 87.1843 21.1627C87.4065 19.7621 88.5564 18.7319 90.0273 18.7319C90.3165 18.7319 90.5846 18.7707 90.8209 18.8483C91.9109 19.1976 92.5317 20.2454 92.3518 21.3815Z",
              fill: "#0070E0"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              d: "M68.9375 16.2305L65.8899 21.378L64.3414 16.2693C64.2921 16.1035 64.1369 15.9906 63.964 15.9906H61.2127C61.0117 15.9906 60.8706 16.1846 60.9305 16.3752L63.703 24.9802L61.1951 29.0339C61.0716 29.2315 61.2163 29.4855 61.4455 29.4855H64.4085C64.5813 29.4855 64.74 29.3938 64.8282 29.2491L72.5706 16.4387C72.6906 16.2411 72.5459 15.9906 72.3167 15.9906H69.3537C69.1809 15.9906 69.0186 16.0823 68.9305 16.2305",
              fill: "#003087"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              d: "M98.9126 11.8309L96.6657 26.0773C96.6304 26.2996 96.8033 26.5007 97.0255 26.5007H99.6886C99.8826 26.5007 100.048 26.3596 100.077 26.169L102.324 11.9226C102.359 11.7004 102.186 11.5028 101.964 11.5028H99.3006C99.1066 11.5028 98.9408 11.6439 98.9126 11.8344",
              fill: "#0070E0"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              d: "M28.0103 18.0086C27.4389 21.2651 24.7793 23.7312 21.2943 23.7312H19.0792C18.6277 23.7312 18.1727 24.1475 18.0986 24.6097L17.1286 30.7662C17.0722 31.1155 16.9099 31.2319 16.5537 31.2319H12.9946C12.6348 31.2319 12.5502 31.1119 12.6066 30.7556L13.0087 26.5007L8.73363 26.2785C8.37384 26.2785 8.23981 26.0774 8.29624 25.7246L11.2133 7.22682C11.2698 6.87754 11.4884 6.72583 11.8412 6.72583H19.2379C22.8005 6.72583 25.0509 9.1214 25.326 12.2296C27.446 13.6656 28.4371 15.5672 28.0103 18.0086Z",
              fill: "#001C64"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              d: "M14.0952 19.6068L13.0088 26.4972L12.328 30.8226C12.2716 31.179 12.5467 31.5 12.9065 31.5H16.6666C17.0229 31.5 17.3227 31.2425 17.3791 30.8932L18.3703 24.6097C18.4267 24.2604 18.7266 24.0028 19.0828 24.0028H21.298C24.7865 24.0028 27.7423 21.4591 28.2855 18.0122C28.67 15.5637 27.439 13.3374 25.3332 12.2332C25.3297 12.4907 25.305 12.7483 25.2662 13.0093C24.7265 16.4563 21.7671 19 18.2786 19H14.8148C14.4585 19 14.1587 19.2576 14.1023 19.6068",
              fill: "#0070E0"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              d: "M13.0088 26.5007H8.63491C8.27513 26.5007 8 26.1797 8.05644 25.8233L11.0088 7.10683C11.0652 6.75755 11.365 6.5 11.7213 6.5H19.2415C22.8006 6.5 25.3896 9.09314 25.3296 12.2296C24.4443 11.7639 23.4037 11.4993 22.2609 11.4993H15.9929C15.6401 11.4993 15.3368 11.7568 15.2803 12.1061L14.0987 19.6068L13.0123 26.4972L13.0088 26.5007Z",
              fill: "#003087"
            }
          )
        ] })
      ]
    }
  );
}
Pt.displayName = "IconPaypal";
function Tt({ className: e, asChild: r = !1 }) {
  const t = r ? Z : "svg";
  return /* @__PURE__ */ l.jsx(
    t,
    {
      className: F(e, "fill-[--brand-followus]"),
      fill: "none",
      height: "32",
      viewBox: "0 0 28 28",
      width: "28",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ l.jsx("path", { d: "M24 0C26.1875 0 28 1.8125 28 4V24C28 26.25 26.1875 28 24 28H9.625C10.25 27 11 25.5 11.3125 24.3125C11.5 23.625 12.3125 20.6875 12.3125 20.6875C12.8125 21.625 14.25 22.4375 15.8125 22.4375C20.4375 22.4375 23.75 18.1875 23.75 12.875C23.75 7.8125 19.625 4 14.3125 4C7.6875 4 4.1875 8.5 4.1875 13.3125C4.1875 15.5625 5.375 18.375 7.3125 19.25C7.5625 19.375 7.75 19.3125 7.8125 19.0625C7.8125 19 7.875 18.75 7.9375 18.5C8 18.125 8.125 17.625 8.25 17.3125C8.25 17.1875 8.25 17 8.125 16.875C7.5 16.125 7 14.6875 7 13.375C7 10 9.5625 6.6875 13.875 6.6875C17.6875 6.6875 20.3125 9.3125 20.3125 12.9375C20.3125 17.125 18.25 20 15.5 20C14 20 12.875 18.75 13.1875 17.1875C13.375 16.5625 13.5625 15.875 13.8125 15.1875C14.125 14.0625 14.5 12.9375 14.5 12.125C14.5 8.8125 9.75 9.25 9.75 13.6875C9.75 15 10.25 15.9375 10.25 15.9375C9.875 17.375 9.625 18.5625 9.375 19.5625C8.1875 24.375 8.0625 25 8.375 28H8.5H4C1.75 28 0 26.25 0 24V4C0 1.8125 1.75 0 4 0H24Z" })
    }
  );
}
Tt.displayName = "IconPinterest";
function lo(e) {
  return /* @__PURE__ */ l.jsx(A, { ...e, children: /* @__PURE__ */ l.jsx(Rr, {}) });
}
function io(e) {
  return /* @__PURE__ */ l.jsx(A, { ...e, children: /* @__PURE__ */ l.jsx(Nr, {}) });
}
function co(e) {
  return /* @__PURE__ */ l.jsx(A, { ...e, children: /* @__PURE__ */ l.jsx(Pr, {}) });
}
function zt({ className: e, asChild: r = !1 }) {
  const t = r ? Z : "svg";
  return /* @__PURE__ */ l.jsxs(
    t,
    {
      className: F(e),
      fill: "none",
      height: "38",
      viewBox: "0 0 79 38",
      width: "79",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ l.jsx("rect", { height: "38", width: "78.5237" }),
        /* @__PURE__ */ l.jsx(
          "path",
          {
            d: "M38.9584 9.3593L34.7813 28.7045H29.7295L33.91 9.3593H38.9618H38.9584ZM60.2133 21.8476L62.8714 14.5843L64.4039 21.8476H60.2133ZM65.8516 28.7011H70.5237L66.445 9.35594H62.1323C61.1626 9.35594 60.3455 9.91337 59.9827 10.7764L52.4016 28.7011H57.7077L58.7621 25.8133H65.2447L65.8516 28.7011ZM52.6661 22.3848C52.6864 17.2774 45.5359 16.9987 45.5868 14.7186C45.6003 14.0235 46.2683 13.2881 47.7295 13.0967C48.4551 13.0027 50.4487 12.9322 52.7135 13.9631L53.5985 9.85964C52.3847 9.4231 50.8183 9 48.8721 9C43.878 9 40.3621 11.6293 40.3349 15.3936C40.3044 18.1773 42.8439 19.732 44.7595 20.6588C46.726 21.6058 47.3871 22.2136 47.3803 23.0631C47.3668 24.3627 45.8105 24.9335 44.356 24.957C41.8166 24.9973 40.3417 24.2787 39.1652 23.7347L38.2498 27.9725C39.4297 28.5097 41.6097 28.9765 43.8678 29C49.1739 29 52.6491 26.4009 52.6661 22.3815M31.7367 9.3593L23.5521 28.7045H18.2121L14.1842 13.268C13.9401 12.3177 13.7265 11.9684 12.984 11.5688C11.7702 10.9174 9.76305 10.3029 8 9.92344L8.12206 9.36266H16.7203C17.8154 9.36266 18.802 10.0846 19.0495 11.3338L21.1788 22.5292L26.4374 9.36266H31.7469L31.7367 9.3593Z",
            fill: "#1A1F70"
          }
        )
      ]
    }
  );
}
zt.displayName = "IconVisa";
function uo(e) {
  return /* @__PURE__ */ l.jsx(A, { ...e, children: /* @__PURE__ */ l.jsx($r, {}) });
}
function Ot({ className: e, asChild: r = !1 }) {
  const t = r ? Z : "svg";
  return /* @__PURE__ */ l.jsx(
    t,
    {
      className: F(e, "fill-[--brand-followus]"),
      fill: "none",
      height: "32",
      viewBox: "0 0 28 28",
      width: "28",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ l.jsx("path", { d: "M17.625 14.0625L11.625 17.4375V10.6875L17.625 14.0625ZM24 0C26.1875 0 28 1.8125 28 4V24C28 26.25 26.1875 28 24 28H4C1.75 28 0 26.25 0 24V4C0 1.8125 1.75 0 4 0H24ZM24.875 8.5625C24.625 7.5625 23.8125 6.75 22.875 6.5C21.0625 6 14 6 14 6C14 6 6.875 6 5.0625 6.5C4.125 6.75 3.3125 7.5625 3.0625 8.5625C2.625 10.3125 2.625 14.0625 2.625 14.0625C2.625 14.0625 2.625 17.75 3.0625 19.5625C3.3125 20.5625 4.125 21.3125 5.0625 21.5625C6.875 22 14 22 14 22C14 22 21.0625 22 22.875 21.5625C23.8125 21.3125 24.625 20.5625 24.875 19.5625C25.375 17.75 25.375 14.0625 25.375 14.0625C25.375 14.0625 25.375 10.3125 24.875 8.5625Z" })
    }
  );
}
Ot.displayName = "IconYoutube";
export {
  Zt as A,
  Ft as B,
  hr as C,
  Gt as D,
  Wt as E,
  Yt as F,
  Bt as G,
  Sr as H,
  Rt as I,
  Jt as J,
  Ut as K,
  Z as L,
  yr as M,
  Zr as N,
  Xt as O,
  ir as P,
  dr as Q,
  Kt as R,
  qt as S,
  Nr as T,
  Dt as U,
  Hr as V,
  Rr as W,
  $r as X,
  _r as Y,
  Qt as a,
  eo as b,
  ro as c,
  to as d,
  St as e,
  oo as f,
  At as g,
  Nt as h,
  no as i,
  It as j,
  so as k,
  ao as l,
  Pt as m,
  Tt as n,
  lo as o,
  io as p,
  co as q,
  zt as r,
  uo as s,
  Ot as t,
  F as u,
  jt as v,
  Ur as w,
  l as x,
  k as y,
  A as z
};
